export const SERVER_IP = "lagiungla.it";
export const DISCORD_URL = "https://discord.gg/JGysvJVAJ3";
export const SUPPORTED_VERSIONS = "26.2";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/e82e5f82-c826-4825-8490-962df3d21367/images/9eec5125928b1b91b82870e17ec208dfa99e8379d10c3109e37b7ad9f206ad8e.png",
  rules: "https://static.prod-images.emergentagent.com/jobs/e82e5f82-c826-4825-8490-962df3d21367/images/29a9ac8de3852b96d4ce41ffb8228aee8a71567709f4673f915c9e3f7a0ad17a.png",
  staff: "https://static.prod-images.emergentagent.com/jobs/e82e5f82-c826-4825-8490-962df3d21367/images/7fd8d43ff413a4d5d494cc9d3ed8fde19545b4f4b7656af6c36c1cdca3c530a3.png",
  store: "https://static.prod-images.emergentagent.com/jobs/e82e5f82-c826-4825-8490-962df3d21367/images/e69ffc6d09c20402e2da9e29f3fd764909d1b94d0997dcc395ea5d9d1a688792.png",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Regolamento", path: "/regolamento" },
  { label: "Staff & Sanzioni", path: "/staff" },
];
